import { graphql } from '@/gql';
import type { AddScheduledGroceryToCartMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addScheduledGroceryToCart = async ({
  scheduledGroceryId,
  email,
  isClearPreviousItems,
}: AddScheduledGroceryToCartMutationVariables): Promise<string> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddScheduledGroceryToCart($scheduledGroceryId: Float!, $email: String!, $isClearPreviousItems: Boolean) {
        addScheduledGroceryToCart(scheduledGroceryId: $scheduledGroceryId, email: $email, isClearPreviousItems: $isClearPreviousItems)
      }
    `),
    variables: {
      scheduledGroceryId,
      email,
      isClearPreviousItems,
    },
  });

  return response.data?.addScheduledGroceryToCart!;
};
